import { BaseStore, getOrCreateStore } from '@Di'
import { action, computed, observable } from 'mobx'
import { compose, pick, propEq } from 'ramda'

export const Collection = compose(
  observable,
  pick([
    'id',
    'name',
    'slug',
    'hub_id',
    'tags',
    'index',
    'archived',
    'min_role',
    'asset_count',
    'tag_counts',
  ])
)

export class CollectionsStore extends BaseStore {
  AllCollection = Collection({ id: 0, name: 'All', slug: '' })

  @observable collection = [this.AllCollection]

  @computed
  get collections() {
    return this.collection
  }

  get getCollectionByTagName() {
    // Implement filters
    return this.collection[0]
  }

  @computed
  get nextCollection() {
    return this.getCollectionByTagName ? this.getNext(this.getCollectionByTagName) : null
  }

  @computed
  get prevCollection() {
    return this.getCollectionByTagName ? this.getPrev(this.getCollectionByTagName) : null
  }

  getCollectionBySlug = (slug) => {
    return this.collections.find((x) => x.slug === slug)
  }

  @action
  load(collections) {
    this.collection.replace([this.AllCollection].concat(collections.map(Collection)))
  }

  @action
  add(collection) {
    const existing = this.getById(collection.id)
    if (existing) {
      Object.assign(existing, collection)
    } else {
      this.collection.push(collection)
    }
  }

  @action
  remove(collection) {
    this.collection.remove(collection)
  }

  getBy(prop, value) {
    return this.collection.find(propEq(prop, value))
  }

  getBySlug(slug) {
    return this.getBy('slug', slug)
  }

  getById(id) {
    return this.getBy('id', id)
  }

  getNext(collection) {
    const idx = this.collection.indexOf(collection)
    if (idx >= 0 && idx < this.collection.length - 1) {
      return this.collection[idx + 1]
    } else {
      return null
    }
  }

  getPrev(collection) {
    const idx = this.collection.indexOf(collection)
    if (idx >= 1) {
      return this.collection[idx - 1]
    } else {
      return null
    }
  }

  fetchCollections = async (hubId) => {
    const resp = await this.request({
      path: `/hubs/${hubId}/collections`,
      query: { limit: 100 },
    })
    this.load(resp.data)
    return this.collection
  }
}

export default getOrCreateStore('CollectionsStore', CollectionsStore)
